module.exports = __webpack_public_path__ + "assets/images/client-9.d601af04.jpeg";